import { FC } from 'react';
// Redux
import { useAppSelector } from 'app/hooks/useStore';
// Selectors
import { selectInvoicesSummary } from 'app/store/BillingInvoices/BillingInvoices.selectors';
// Mui
import { Box } from '@mui/material';
// Components
import { InfoBlock } from 'app/components/Utilities';
// Utilities
import { toNumberWithCommas } from 'app/utilities/Utilities';
// i18next
import { useTranslation } from 'react-i18next';

const InvoicesSummary:FC = () => {
  const { t } = useTranslation();
  // State
  const invoicesSummary = useAppSelector(selectInvoicesSummary);

  return (
    <Box>
      {invoicesSummary ? (
        <InfoBlock
          label={t('pages.amBillingInvoices.totalAmount')}
          value={`$${toNumberWithCommas(invoicesSummary.amount)}`}
          direction="row"
        />
      ) : null}
    </Box>
  )
}

export default InvoicesSummary;
